import { IVacationRequestParams } from "Dashboard/scenes/Carnets/domain/IVacationRequestParams";
import { useAppDispatch } from "hooks/hooks";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import {
  createCarnets,
  selectEmployee,
  setVacationPopover,
} from "../main.slice";
import DatePicker from "react-datepicker";
import { ICarnetCreate } from "Dashboard/scenes/Carnets/domain/ICarnetCreate";
import { CarnetType } from "Dashboard/scenes/Carnets/domain/CarnetType";
import { AbsenceType } from "Dashboard/scenes/Carnets/domain/AbsenceType";
import { FormatDateIso } from "utils/dateUtils";
import { toast } from "react-toastify";
import classes from "../../../../../../components/Popover/popover.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";

const VacationPopover = () => {
  const dispatch = useAppDispatch();
  const employee = useSelector(selectEmployee);

  const resetForm = () => {
    reset();
  };

  const close = () => {
    dispatch(setVacationPopover({ isOpen: false }));
    resetForm();
  };

  const defaultValues: IVacationRequestParams = {
    vacationStartDate: null,
    vacationEndDate: null,
  };

  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm<IVacationRequestParams>({
    defaultValues,
  });

  const onSubmit = async (data: IVacationRequestParams) => {
    try {
      const payload: ICarnetCreate[] = [];
      if (data.vacationStartDate != null && data.vacationEndDate != null) {
        let date = new Date(data.vacationStartDate);
        let endDate = new Date(data.vacationEndDate);
        while (date <= endDate) {
          payload.push({
            employeeId: employee.employeeId,
            carnetType: CarnetType.ABSENCE,
            absenceType: AbsenceType.VACATION,
            carnetDate: FormatDateIso(date),
          });
          var newDate = date.setDate(date.getDate() + 1);
          date = new Date(newDate);
        }
      }
      await dispatch(createCarnets({ carnets: payload })).unwrap();
      toast.success(
        `Odmor je uspešno unešen za zaposlenog ${employee.employeeName}`
      );
      close();
    } catch (status) {
      if (status === 404) {
        toast.error("Nije moguć unos karneta jer neki od unetih parametara nije regularan.");
      } else if (status === 403) {
        toast.error("Nije dozvoljen unos karneta (za izabranog zaposlenog na izabrani dan, ili vi niste zaposleni u firmi, ...).");
      } else if (status === 412) {
        toast.error("Nije dozvoljen unos karneta jer nisu podešene vrednosti za bolovanje i odmor u podešavanjima aplikacije.");
      } else if (status === 400) {
        toast.error("Karneti nisu uneti zbog neočekivane greške.");
      }
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}
      className={`
        ${classes.basicPopoverView}
        ${classes.gPopoverInputs}
      `}
    >
      <div className={`${errors.vacationStartDate ? classes.inputError : ""}`}>
        <div>
          <label>Datum početka odmora:</label>
          <Controller
            control={control}
            name="vacationStartDate"
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange, value } }) => (
              <div className={classes.dateWrapper}>
                <DatePicker
                  onChange={(date) =>
                    onChange(date ? FormatDateIso(date) : undefined)
                  }
                  showMonthDropdown
                  showYearDropdown
                  dateFormat="dd.MM.yyyy"
                  selected={value ? new Date(value) : null}
                  className={classes.dotField}
                />
              </div>
            )}
          />
        </div>
      </div>

      <div
        className={`${errors.vacationEndDate ? classes.inputError : ""}`}
      >
        <div>
          <label>Datum završetka odmora:</label>

          <Controller
            control={control}
            name="vacationEndDate"
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange, value } }) => (
              <div className={classes.dateWrapper}>
                <DatePicker
                  onChange={(date) =>
                    onChange(date ? FormatDateIso(date) : undefined)
                  }
                  showMonthDropdown
                  showYearDropdown
                  dateFormat="dd.MM.yyyy"
                  selected={value ? new Date(value) : null}
                  className={classes.dotField}
                />
              </div>
            )}
          />
        </div>
      </div>

      <div className={classes.buttons}>
        <button type="submit" className={classes.iconButton}>
          <FontAwesomeIcon
            icon={faLongArrowAltDown}
            className={classes.icon} />
        </button>
      </div>
    </form>
  );
};

export default VacationPopover;
